{
  "common": {
    "loading": "Laster inn...",
    "cancel": "Kansellere",
    "save": "Spare",
    "delete": "Slett",
    "edit": "Redigere",
    "close": "Lukke",
    "submit": "Send inn",
    "saving": "Lagrer...",
    "sending": "Sender...",
    "error": "Feil",
    "success": "Suksess",
    "warning": "Advarsel",
    "no_data": "Ingen data",
    "yes": "Ja",
    "no": "Ingen",
    "back": "Tilbake",
    "next": "Neste",
    "previous": "Tidligere",
    "search": "Søk",
    "filter": "Filter",
    "all": "Alle",
    "none": "Ingen",
    "select": "Velge",
    "required": "Obligatorisk",
    "optional": "Valgfri",
    "actions": "Handlinger",
    "status": "Status",
    "date": "Dato",
    "time": "Tid",
    "name": "Navn",
    "email": "E-post",
    "confirm": "Bekrefte",
    "add": "Legg til",
    "done": "Ferdig",
    "unknown": "Ukjent",
    "days": "dager",
    "to": "til",
    "save_changes": "Lagre endringer",
    "note": "Merk"
  },
  "time": {
    "day": "dag",
    "days": "dager",
    "hour": "time",
    "hours": "timer",
    "week": "uke",
    "weeks": "uker",
    "month": "måned",
    "months": "måneder",
    "year": "år",
    "years": "år",
    "today": "I dag",
    "tomorrow": "I morgen",
    "yesterday": "I går"
  },
  "status": {
    "pending": "I påvente av",
    "approved": "Godkjent",
    "rejected": "Avvist",
    "cancelled": "Avlyst",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "deleted": "Slettet",
    "connected": "Tilkoblet",
    "disconnected": "Frakoblet",
    "available": "Tilgjengelig",
    "coming_soon": "Kommer snart"
  },
  "nav": {
    "dashboard": "Dashbord",
    "planner": "Planlegger",
    "team": "Team",
    "requests": "Forespørsler",
    "calendar": "Kalender",
    "settings": "Innstillinger",
    "audit_trail": "Revisjonsspor",
    "billing": "Fakturering",
    "help": "Hjelp",
    "help_center": "Hjelpesenter",
    "profile": "Profil",
    "my_balances": "Mine saldoer",
    "leave_history": "Permisjonshistorikk",
    "restart_tour": "Start turen på nytt",
    "logout": "Logg ut",
    "upgrade": "Oppgrader til Pro",
    "upgrade_subtitle": "Lås opp alle funksjoner",
    "view_plans": "Se planer"
  },
  "header": {
    "profile_settings": "Profilinnstillinger",
    "my_profile": "Min profil",
    "workspace": "Arbeidsområde",
    "leave_balances": "Permisjonssaldoer",
    "no_balances": "Ingen permisjonssaldoer funnet."
  },
  "balance": {
    "unlimited": "Ubegrenset",
    "days_left": "dager igjen",
    "used": "brukt",
    "remaining": "gjenværende",
    "of": "av"
  },
  "trial": {
    "ends_today": "Prøveperioden din avsluttes i dag!",
    "ends_tomorrow": "Prøveperioden din avsluttes i morgen!",
    "ends_in_days": "Prøveperioden avsluttes om {days} dager.",
    "upgrade_now": "Oppgrader nå"
  },
  "feature_locked": {
    "title": "{feature} er ikke tilgjengelig i abonnementet ditt",
    "description": "Oppgrader abonnementet ditt for å låse opp denne funksjonen og mer.",
    "button": "Se planer"
  },
  "dashboard": {
    "title": "Dashbord",
    "out_today": "Ute i dag",
    "out_on_date": "Ute på {dato}",
    "no_absences": "Ingen fravær",
    "upcoming": "Kommende fravær",
    "upcoming_empty": "Ingen kommende fravær denne uken",
    "my_balance": "Min permisjonssaldo",
    "my_balances": "Mine saldoer",
    "no_balance_data": "Ingen saldodata",
    "next_holiday": "Neste offentlige fridag",
    "no_holidays": "Ingen kommende ferier",
    "next_vacation": "Min neste ferie",
    "nothing_booked": "Ingenting booket!",
    "upcoming_birthdays": "Kommende bursdager",
    "no_birthdays": "Ingen kommende bursdager",
    "birthday_today": "I dag!",
    "birthday_in_days": "om {days} {unit}",
    "everyone_in_office": "Alle er på kontoret denne dagen",
    "request_leave": "Be om permisjon",
    "view_calendar": "Vis kalender",
    "view_planner": "Vis Planlegger",
    "contact_support": "Kontakt kundestøtte"
  },
  "support": {
    "title": "Kontakt kundestøtte",
    "success_title": "Melding sendt!",
    "success_message": "Vi tar kontakt med deg så snart som mulig.",
    "intro": "Trenger du hjelp? Send oss ​​en melding, så tar vi kontakt med deg snart.",
    "subject_label": "Tema",
    "subject_placeholder": "Kort beskrivelse av problemet ditt",
    "message_label": "Beskjed",
    "message_placeholder": "Vennligst beskriv problemet eller spørsmålet ditt i detalj ...",
    "send_button": "Send melding"
  },
  "requests": {
    "page_title": "Permisjonsforespørsler",
    "page_subtitle": "Gjennomgå og administrer permisjonsforespørsler",
    "new_request": "Be om permisjon",
    "unpaid_confirm": "Bare {paid} {unit} av denne forespørselen dekkes av din betalte saldo. De resterende {unpaid} {unit} tas som ulønnet ferie. Vil du sende likevel?",
    "filter": {
      "pending": "I påvente av",
      "approved": "Godkjent",
      "rejected": "Avvist",
      "all": "Alle",
      "all_employees": "Alle ansatte"
    },
    "table": {
      "employee": "Ansatt",
      "type": "Type",
      "dates": "Datoer",
      "duration": "Varighet",
      "status": "Status",
      "reason": "Grunn",
      "actions": "Handlinger"
    },
    "action": {
      "approve": "Vedta",
      "reject": "Avvis",
      "cancel": "Kansellere"
    },
    "empty": {
      "title": "Ingen forespørsler funnet",
      "pending": "Ingen ventende forespørsler om gjennomgang.",
      "filtered": "Ingen permisjonsforespørsler samsvarer med filteret ditt."
    },
    "modal": {
      "reject_title": "Avvis forespørsel",
      "reason_label": "Årsak til avslag",
      "reason_placeholder": "Årsak til permisjonssøknad...",
      "reject_button": "Avvis",
      "request_title": "Be om permisjon",
      "employee_label": "Ansatt",
      "leave_type_label": "Permisjonstype",
      "start_date_label": "Startdato",
      "end_date_label": "Sluttdato",
      "start_time_label": "Starttid",
      "end_time_label": "Sluttid",
      "reason_optional": "Årsak (valgfritt)",
      "submit_button": "Send inn forespørsel",
      "submitting": "Sender inn...",
      "minimum_duration": "Minimum: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Teamkalender",
    "page_subtitle": "Se teamfravær og planlagt permisjon",
    "filters": {
      "button": "Filtre"
    },
    "sync": {
      "title": "Synkroniser kalenderen din",
      "description": "Koble til din personlige kalender for å automatisk synkronisere godkjent permisjon"
    },
    "connect": {
      "google": "Google Kalender",
      "microsoft": "Microsoft Kalender"
    },
    "action": {
      "disconnect": "Frakople",
      "sync_my_leave": "Synkroniser permisjonen min",
      "sync_team_leave": "Synkroniser teampermisjon"
    },
    "connecting": "Kobler til...",
    "syncing": "Synkroniserer...",
    "autosync": {
      "title": "Automatisk synkronisering av teampermisjon",
      "description": "Legg automatisk til godkjente permisjoner for teammedlemmer i kalenderen din"
    },
    "filter": {
      "department_label": "Avdeling",
      "all_departments": "Alle avdelinger",
      "location_label": "Sted",
      "all_locations": "Alle steder",
      "leave_type_label": "Permisjonstype",
      "all_types": "Alle typer",
      "status_label": "Status",
      "all_status": "All status"
    },
    "nav": {
      "today": "I dag"
    },
    "view": {
      "day": "Dag",
      "week": "Uke",
      "month": "Måned"
    },
    "legend": {
      "pending": "I påvente av",
      "holiday": "Ferie"
    },
    "day_view": {
      "empty": "Ingen blader denne dagen"
    },
    "more": "+{count} mer"
  },
  "team": {
    "page_title": "Team",
    "page_subtitle": "Administrer teammedlemmene dine",
    "tab": {
      "active": "Aktive",
      "inactive": "Inaktive",
      "deleted": "Slettede"
    },
    "add_user": "Legg til bruker",
    "import_from_slack": "Importer fra Slack",
    "search_placeholder": "Søk etter teammedlemmer...",
    "bulk_import": "Masseimport",
    "invite_member": "Inviter medlem",
    "table": {
      "name": "Navn",
      "email": "E-post",
      "department": "Avdeling",
      "location": "Sted",
      "role": "Rolle",
      "status": "Status",
      "manager": "Leder",
      "start_date": "Startdato",
      "actions": "Handlinger"
    },
    "filter": {
      "all_departments": "Alle avdelinger",
      "all_locations": "Alle steder",
      "all_roles": "Alle roller",
      "search_placeholder": "Søk etter navn eller e-post..."
    },
    "role": {
      "owner": "Eier",
      "admin": "Administrator",
      "approver": "Godkjenner",
      "employee": "Ansatt"
    },
    "card": {
      "department": "Avdeling",
      "location": "Sted",
      "manager": "Leder",
      "birthday": "Bursdag",
      "start_date": "Startdato",
      "working_days": "Arbeidsdager",
      "hours_per_week": "Timer per uke",
      "employment_type": "Ansettelsestype",
      "full_time": "Heltid",
      "part_time": "Deltid",
      "contractor": "Konsulent",
      "no_manager": "Ingen leder",
      "no_department": "Ingen avdeling",
      "no_location": "Ingen sted"
    },
    "action": {
      "edit": "Rediger",
      "view": "Vis",
      "deactivate": "Deaktiver",
      "activate": "Aktiver",
      "delete": "Slett",
      "restore": "Gjenopprett",
      "permanent_delete": "Slett permanent",
      "manage_balances": "Administrer saldoer",
      "view_history": "Vis historikk",
      "send_reminder": "Send påminnelse"
    },
    "empty": {
      "title": "Ingen teammedlemmer funnet",
      "description": "Legg til teammedlemmer for å komme i gang",
      "active": "Ingen aktive brukere",
      "inactive": "Ingen inaktive brukere",
      "deleted": "Ingen slettede brukere",
      "filtered": "Ingen brukere samsvarer med filteret ditt"
    },
    "modal": {
      "edit_title": "Rediger bruker",
      "add_title": "Legg til bruker",
      "name_label": "Fullt navn",
      "email_label": "E-post",
      "department_label": "Avdeling",
      "location_label": "Sted",
      "role_label": "Rolle",
      "manager_label": "Leder",
      "birthday_label": "Bursdag",
      "start_date_label": "Startdato",
      "working_days_label": "Arbeidsdager",
      "hours_per_week_label": "Timer per uke",
      "employment_type_label": "Ansettelsestype",
      "select_department": "Velg avdeling",
      "select_location": "Velg sted",
      "select_manager": "Velg leder",
      "select_role": "Velg rolle",
      "no_manager": "Ingen leder"
    },
    "toil": {
      "title": "Avspasering (TOIL)",
      "description": "Administrer avspasering for denne brukeren",
      "add_hours": "Legg til timer",
      "remove_hours": "Fjern timer",
      "current_balance": "Nåværende saldo",
      "hours": "timer",
      "reason": "Årsak",
      "reason_placeholder": "Grunn til justering..."
    },
    "invite": {
      "title": "Inviter teammedlem",
      "description": "Send en invitasjon via Slack",
      "email_label": "E-postadresse",
      "email_placeholder": "bruker@firma.com",
      "message_label": "Personlig melding (valgfritt)",
      "message_placeholder": "Legg til en personlig melding...",
      "send_button": "Send invitasjon",
      "success": "Invitasjon sendt!",
      "error": "Kunne ikke sende invitasjon"
    },
    "bulk": {
      "title": "Masseimport av brukere",
      "description": "Importer flere brukere fra en CSV-fil",
      "download_template": "Last ned CSV-mal",
      "upload_file": "Last opp CSV-fil",
      "drag_drop": "Dra og slipp filen din her, eller klikk for å velge",
      "supported_formats": "Støttede formater: CSV",
      "preview": "Forhåndsvisning",
      "import_button": "Importer brukere",
      "importing": "Importerer...",
      "success": "{count} brukere importert",
      "error": "Kunne ikke importere brukere",
      "validation_error": "Noen rader har feil"
    },
    "instances": {
      "title": "Permisjonsforekomster",
      "description": "Spor permisjon per forekomst (f.eks. foreldrepermisjon)",
      "instance": "Forekomst",
      "start_date": "Startdato",
      "end_date": "Sluttdato",
      "days_used": "Dager brukt",
      "days_remaining": "Dager igjen",
      "add_instance": "Legg til forekomst"
    },
    "confirm": {
      "deactivate": "Er du sikker på at du vil deaktivere denne brukeren?",
      "deactivate_description": "Brukeren vil ikke lenger kunne logge inn eller sende permisjonsforespørsler.",
      "activate": "Er du sikker på at du vil aktivere denne brukeren?",
      "activate_description": "Brukeren vil kunne logge inn og sende permisjonsforespørsler igjen.",
      "delete": "Er du sikker på at du vil slette denne brukeren?",
      "delete_description": "De vil bli flyttet til Slettede-fanen og kan gjenopprettes senere.",
      "permanent_delete": "Er du sikker på at du vil SLETTE {name} PERMANENT?",
      "permanent_delete_warning": "Denne handlingen kan ikke angres. All permisjonshistorikk og saldo vil bli slettet.",
      "permanent_delete_final": "Dette er permanent! Klikk OK for å bekrefte permanent sletting.",
      "restore": "Er du sikker på at du vil gjenopprette denne brukeren?",
      "restore_description": "Brukeren vil bli flyttet tilbake til Aktive-fanen."
    },
    "error": {
      "load": "Kunne ikke laste teammedlemmer",
      "save": "Kunne ikke lagre bruker",
      "deactivate": "Kunne ikke deaktivere brukeren",
      "activate": "Kunne ikke aktivere brukeren",
      "delete": "Kunne ikke slette brukeren",
      "restore": "Kunne ikke gjenopprette brukeren",
      "permanent_delete": "Kunne ikke slette brukeren permanent",
      "import": "Kunne ikke importere brukere",
      "invite": "Kunne ikke sende invitasjon"
    }
  },
  "settings": {
    "page_title": "Innstillinger",
    "page_subtitle": "Konfigurer innstillinger og retningslinjer for arbeidsområdet ditt",
    "access_denied": {
      "title": "Administratortilgang kreves",
      "message": "Du trenger administratorrettigheter for å få tilgang til innstillingene."
    },
    "tab": {
      "workspace": "Arbeidsområde",
      "departments": "Avdelinger",
      "locations": "Steder",
      "holidays": "Helligdager",
      "compliance": "Samsvar",
      "balances": "Åpningsbalanser",
      "notifications": "Varsler",
      "integrations": "Integrasjoner",
      "import": "Import",
      "data_management": "Datahåndtering",
      "locked_tooltip": "Oppgrader for å låse opp denne funksjonen"
    },
    "workspace": {
      "title": "Innstillinger for arbeidsområde",
      "name_label": "Navn på arbeidsområde",
      "visibility_label": "Forlat synlighet",
      "visibility": {
        "all": "Alle kan se at alle forlater",
        "department": "Se bare egen avdeling",
        "approvers": "Bare godkjennere kan se alle"
      },
      "save_button": "Lagre endringer"
    },
    "departments": {
      "title": "Avdelinger",
      "subtitle": "Organiser teamet ditt i avdelinger med tilpassede retningslinjer",
      "add_button": "Legg til avdeling",
      "name_label": "Avdelingsnavn",
      "working_days_label": "Arbeidsdager",
      "hours_per_day_label": "Timer per dag",
      "approvers_label": "Godkjennere",
      "notification_channel_label": "Varslingskanal",
      "policies_button": "Administrer retningslinjer",
      "edit_button": "Redigere",
      "delete_button": "Slett",
      "confirm_delete": "Er du sikker på at du vil slette denne avdelingen?",
      "no_departments": "Ingen avdelinger opprettet ennå"
    },
    "locations": {
      "title": "Steder",
      "subtitle": "Administrer kontorlokasjoner og deres feriekalendere",
      "add_button": "Legg til plassering",
      "name_label": "Stedsnavn",
      "country_label": "Land",
      "timezone_label": "Tidssone",
      "edit_button": "Redigere",
      "delete_button": "Slett",
      "no_locations": "Ingen steder er opprettet ennå"
    },
    "holidays": {
      "title": "Helligdager",
      "subtitle": "Administrer helligdager for hvert sted",
      "add_button": "Legg til ferie",
      "location_label": "Sted",
      "all_locations": "Alle steder",
      "year_label": "År",
      "name_label": "Ferienavn",
      "date_label": "Dato",
      "half_day_label": "Halv dag",
      "edit_button": "Redigere",
      "delete_button": "Slett",
      "no_holidays": "Ingen helligdager for dette stedet og året",
      "import_button": "Importer helligdager"
    },
    "leave_types": {
      "title": "Permisjonstyper",
      "subtitle": "Konfigurer permisjonstyper og rettigheter",
      "add_button": "Legg til permisjonstype",
      "name_label": "Navn",
      "color_label": "Farge",
      "unit_label": "Enhet",
      "unit": {
        "days": "Dager",
        "hours": "Timer"
      },
      "entitlement_label": "Standardrettighet",
      "unlimited": "Ubegrenset",
      "requires_approval_label": "Krever godkjenning",
      "allow_half_day_label": "Beregn en halv dag",
      "is_paid_label": "Betalt permisjon",
      "carryover_label": "Maks overføring",
      "priority_label": "Prioritet",
      "edit_button": "Redigere",
      "delete_button": "Slett",
      "no_leave_types": "Ingen permisjonstyper konfigurert"
    },
    "notifications": {
      "title": "Varsler",
      "subtitle": "Konfigurer hvordan og når varsler sendes",
      "slack_channel_label": "Slack-kanalen",
      "email_notifications_label": "E-postvarsler",
      "daily_digest_label": "Daglig sammendrag",
      "weekly_summary_label": "Ukentlig oppsummering",
      "save_button": "Lagre innstillinger"
    },
    "integrations": {
      "title": "Integrasjoner",
      "subtitle": "Koble sammen HR-verktøyene og kalenderne dine",
      "connect_button": "Koble til",
      "disconnect_button": "Frakople",
      "sync_button": "Synkroniser nå",
      "view_logs_button": "Vis logger",
      "last_sync": "Sist synkronisert: {dato}",
      "never_synced": "Aldri synkronisert",
      "status": {
        "connected": "Tilkoblet",
        "disconnected": "Ikke tilkoblet",
        "error": "Feil"
      }
    },
    "data": {
      "title": "Datahåndtering",
      "subtitle": "Sikkerhetskopier dataene dine eller fjern informasjon om arbeidsområdet",
      "current_data": "Gjeldende data",
      "total_users": "Totalt antall brukere",
      "admins": "Administratorer",
      "regular_users": "Vanlige brukere",
      "leave_requests": "Permisjonsforespørsler",
      "backup": {
        "title": "Last ned sikkerhetskopi",
        "description": "Last ned en fullstendig sikkerhetskopi av arbeidsområdedataene dine som en JSON-fil.",
        "button": "Last ned sikkerhetskopi"
      },
      "google_drive": {
        "title": "Google Disk-sikkerhetskopi",
        "description": "Automatiske daglige sikkerhetskopier til Google Drive.",
        "connect_button": "Koble til Google Disk",
        "folder_label": "Sikkerhetskopieringsmappe",
        "auto_backup_label": "Aktiver automatisk daglig sikkerhetskopiering",
        "backup_now_button": "Sikkerhetskopier nå",
        "last_backup": "Siste sikkerhetskopi: {dato}",
        "upgrade_message": "Automatiske daglige sikkerhetskopier til Google Drive er tilgjengelige i Business-abonnementet."
      },
      "clear_users": {
        "title": "Fjern ikke-administratorbrukere",
        "description": "Fjern alle brukere unntatt administratorer og eiere. Dette vil slette {count} brukere, permisjonssaldoene deres og eventuelle ventende permisjonsforespørsler.",
        "warning": "Advarsel: Denne handlingen kan ikke angres. Sørg for å laste ned en sikkerhetskopi først.",
        "confirm_prompt": "Skriv DELETE for å bekrefte",
        "confirm_description": "Dette vil permanent fjerne {count} brukere og alle dataene deres.",
        "button": "Fjern ikke-administratorbrukere",
        "confirm_button": "Bekreft sletting av brukere"
      },
      "clear_history": {
        "title": "Tøm permisjonshistorikk",
        "description": "Fjern alle permisjonsforespørsler og tilbakestill alle permisjonssaldoer til null. Dette vil slette {count} permisjonsforespørsler.",
        "warning": "Advarsel: Denne handlingen kan ikke angres. All permisjonshistorikk vil bli slettet permanent og saldoene nullstilles.",
        "confirm_description": "Dette vil slette {count} permisjonsforespørsler permanent og nullstille alle saldoer.",
        "button": "Tøm permisjonshistorikk",
        "confirm_button": "Bekreft sletting av logg"
      },
      "restore": {
        "title": "Gjenopprett fra sikkerhetskopi",
        "description": "Last opp en sikkerhetskopi av JSON-filen for å gjenopprette arbeidsområdedataene dine. Dette vil erstatte alle eksisterende data.",
        "warning": "Advarsel: Gjenoppretting vil erstatte alle nåværende brukere, permisjonstyper, permisjonsforespørsler, avdelinger og saldoer. Bare eieren av arbeidsområdet kan utføre denne handlingen.",
        "select_file": "Velg sikkerhetskopifil",
        "backup_details": "Sikkerhetskopieringsdetaljer",
        "file": "Fil",
        "version": "Versjon",
        "created": "Opprettet",
        "confirm_prompt": "Skriv GJENOPPRETT for å bekrefte",
        "confirm_description": "Dette vil permanent erstatte alle eksisterende data med sikkerhetskopien.",
        "button": "Bekreft gjenoppretting",
        "restoring": "Gjenoppretter...",
        "success": "Gjenopprettingen er fullført!"
      }
    }
  },
  "audit": {
    "page_title": "Revisjonsspor",
    "page_subtitle": "Se alle endringer som er gjort i arbeidsområdet ditt",
    "super_admin_label": "(Superadministrator)",
    "entries_count": "totalt antall oppføringer",
    "filter": {
      "action_label": "Handlingstype",
      "all_actions": "Alle handlinger",
      "entity_label": "Enhetstype",
      "all_entities": "Alle enheter",
      "user_label": "Endret av",
      "all_users": "Alle brukere"
    },
    "action": {
      "user_updated": "Bruker oppdatert",
      "user_deleted": "Bruker slettet",
      "user_imported": "Brukerimportert",
      "leave_requested": "Forespurt permisjon",
      "leave_approved": "Permisjon godkjent",
      "leave_rejected": "Permisjon avvist",
      "leave_cancelled": "Permisjon avlyst",
      "leave_type_created": "Permisjonstype opprettet",
      "leave_type_updated": "Permisjonstype oppdatert",
      "leave_type_deleted": "La typen være slettet",
      "balance_adjusted": "Justert saldo",
      "department_created": "Avdeling opprettet",
      "department_updated": "Avdeling oppdatert",
      "department_deleted": "Avdeling slettet",
      "audit_log_deleted": "Revisjonslogg slettet"
    },
    "table": {
      "date": "Dato",
      "user": "Bruker",
      "action": "Handling",
      "entity": "Enhet",
      "details": "Detaljer"
    },
    "no_entries": "Ingen oppføringer i revisjonsloggen funnet"
  },
  "billing": {
    "page_title": "Fakturering og abonnement",
    "page_subtitle": "Administrer abonnementet og faktureringsdetaljene dine",
    "access_denied": {
      "title": "Tilgang nektet",
      "message": "Bare eieren av arbeidsområdet kan se og administrere fakturering.",
      "button": "Gå tilbake til dashbordet"
    },
    "current_plan": {
      "title": "Gjeldende plan"
    },
    "status": {
      "none": "Ingen abonnement"
    },
    "discount_badge": "{prosent} % rabatt er brukt",
    "trial_info": {
      "title": "Prøveperioden avsluttes {dato}",
      "days_remaining": "{dager} dager igjen"
    },
    "renewal_info": {
      "title": "Neste faktureringsdato"
    },
    "action": {
      "upgrade": "Oppgrader til Pro",
      "view_plans": "Se alle planer",
      "manage": "Administrer abonnement"
    },
    "plan": {
      "trial": "Gratis prøveperiode",
      "free": "Gratis",
      "pro": "Proff",
      "business": "Forretninger"
    },
    "feature": {
      "up_to_5_users": "Opptil 5 brukere",
      "up_to_50_users": "Opptil 50 brukere",
      "unlimited_users": "Ubegrensede brukere",
      "basic": "Grunnleggende funksjoner",
      "trial_14days": "14-dagers prøveperiode",
      "unlimited_requests": "Ubegrenset antall permisjonsforespørsler",
      "slack_integration": "Slack-integrasjon",
      "planner": "Planleggervisning",
      "custom_leave_types": "Tilpassede permisjonstyper",
      "approval_workflows": "Godkjenningsarbeidsflyter",
      "priority_support": "Prioritert støtte",
      "multi_team": "Støtte for flere team",
      "analytics": "Avansert analyse",
      "api_access": "API-tilgang",
      "dedicated_support": "Dedikert støtte"
    }
  },
  "upgrade": {
    "page_title": "Velg din plan",
    "page_subtitle": "Enkel og transparent prissetting. Ingen gebyrer per bruker.",
    "plan_badge": "Mest populær",
    "period": {
      "month": "/måned",
      "year": "/år"
    },
    "yearly_savings": "eller EUR {årlig}/år (spar {prosent} %)",
    "loading": "Laster inn planer ...",
    "guarantee": {
      "title": "30-dagers pengene-tilbake-garanti",
      "description": "Ikke fornøyd? Få full refusjon, uten spørsmål."
    },
    "faq": {
      "title": "Ofte stilte spørsmål",
      "q1": "Kan jeg endre planer senere?",
      "a1": "Ja, du kan oppgradere eller nedgradere når som helst. Endringene trer i kraft umiddelbart og fordeles forholdsmessig.",
      "q2": "Hvilke betalingsmåter aksepterer dere?",
      "a2": "Vi aksepterer alle større kredittkort (Visa, Mastercard, American Express) gjennom vår sikre betalingsleverandør Stripe.",
      "q3": "Er det en kontrakt eller forpliktelse?",
      "a3": "Nei, alle abonnementene gjelder fra måned til måned. Du kan si opp når som helst uten gebyrer.",
      "q4": "Hva skjer når jeg når brukergrensen min?",
      "a4": "Du vil bli bedt om å oppgradere til en høyere plan. Eksisterende brukere vil fortsatt ha tilgang."
    },
    "contact_note": "Har du spørsmål? Kontakt oss på",
    "current_plan_badge": "Gjeldende plan",
    "button": {
      "upgrade": "Oppgrader til {plan}",
      "start_trial": "Start gratis prøveperiode"
    }
  },
  "login": {
    "processing_title": "Logger deg inn...",
    "processing_message": "Vent mens vi bekrefter legitimasjonen din fra Slack.",
    "subtitle": "Administrer teamets forespørsler om fritid enkelt",
    "slack_button": "Legg til i Slack",
    "existing_user_text": "Bruker du allerede Unplug?",
    "existing_user_info": "Åpne appen i Slack og klikk på «Admin Dashboard» for å logge inn.",
    "terms_text": "Ved å fortsette",
    "error": {
      "workspace_not_found": "Arbeidsområdet ble ikke funnet. Sjekk URL-en.",
      "invalid_response": "Ugyldig svar fra serveren",
      "generic": "Innlogging mislyktes",
      "please_retry": "Innlogging mislyktes. Prøv på nytt."
    }
  },
  "help": {
    "page_title": "Hjelpesenter",
    "page_subtitle": "Finn svar og lær hvordan du bruker Unplug",
    "action": {
      "restart_tour": "Start omvisningen på nytt"
    },
    "search": {
      "placeholder": "Søk i hjelpeartikler, vanlige spørsmål...",
      "results": "Fant {articles} artikler og {faqs} vanlige spørsmål som samsvarer med «{query}»"
    },
    "quick_link": {
      "getting_started": "Komme i gang",
      "faqs": "Vanlige spørsmål",
      "contact_support": "Kontakt kundestøtte",
      "tour": "Ta turen"
    }
  },
  "profile": {
    "page_title": "Profilinnstillinger",
    "personal_info": "Personopplysninger",
    "name_label": "Fullt navn",
    "email_label": "E-post",
    "department_label": "Avdeling",
    "location_label": "Sted",
    "manager_label": "Leder",
    "start_date_label": "Startdato",
    "save_button": "Lagre endringer",
    "preferences": "Innstillinger",
    "language_label": "Språk",
    "timezone_label": "Tidssone"
  },
  "planner": {
    "page_title": "Planlegger",
    "page_subtitle": "Visuell teamkalender som viser alle fravær",
    "feature_name": "Planlegger",
    "feature_description": "Visuell teamkalender som viser alle fravær på et øyeblikk",
    "empty_state": "Ingen teammedlemmer funnet",
    "filter": {
      "pending_request": "Ventende forespørsel",
      "filter_by": "Filtrer etter",
      "department": "Avdeling",
      "all_departments": "Alle avdelinger",
      "location": "Sted",
      "all_locations": "Alle steder"
    },
    "export": {
      "button": "Eksporter",
      "title": "Eksporter permisjonsdata",
      "format": "Eksportformat",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "Generisk CSV",
      "date_range": "Datoperiode",
      "departments": "Avdelinger"
    },
    "legend": {
      "approved": "Godkjent",
      "pending": "Ventende",
      "holiday": "Helligdag",
      "holidays": "Helligdager",
      "weekend": "Helg",
      "non_working": "Ikke-arbeidsdag",
      "partial_day": "Fravær kortere enn en dag"
    },
    "no_data": "Ingen fravær å vise"
  },
  "error": {
    "network": "Nettverksfeil. Sjekk tilkoblingen din.",
    "unauthorized": "Du er ikke autorisert til å utføre denne handlingen.",
    "not_found": "Den forespurte ressursen ble ikke funnet.",
    "server": "Serverfeil. Prøv igjen senere.",
    "validation": "Vennligst sjekk skjemaet for feil.",
    "generic": "Noe gikk galt. Prøv igjen.",
    "session_expired": "Økten din er utløpt. Vennligst logg inn på nytt."
  },
  "success": {
    "saved": "Endringene er lagret.",
    "deleted": "Slettet.",
    "created": "Opprettet.",
    "updated": "Oppdatert.",
    "submitted": "Innsendt.",
    "sent": "Sendt."
  },
  "weekday": {
    "monday": "mandag",
    "tuesday": "tirsdag",
    "wednesday": "onsdag",
    "thursday": "torsdag",
    "friday": "fredag",
    "saturday": "lørdag",
    "sunday": "søndag",
    "mon": "man",
    "tue": "tirsdag",
    "wed": "Ons",
    "thu": "Torsdag",
    "fri": "Fre",
    "sat": "Lør",
    "sun": "Sol"
  },
  "month": {
    "january": "januar",
    "february": "februar",
    "march": "mars",
    "april": "april",
    "may": "mai",
    "june": "juni",
    "july": "juli",
    "august": "august",
    "september": "september",
    "october": "oktober",
    "november": "november",
    "december": "desember",
    "jan": "Jan",
    "feb": "Feb",
    "mar": "Mar",
    "apr": "april",
    "may_short": "mai",
    "jun": "Juni",
    "jul": "Juli",
    "aug": "Aug",
    "sep": "Sep",
    "oct": "okt",
    "nov": "Nov",
    "dec": "Des"
  },
  "language": {
    "en": "Engelsk",
    "es": "Spansk",
    "fr": "Fransk",
    "de": "Tysk",
    "it": "Italiensk",
    "pt": "Portugisisk",
    "pl": "Pusse",
    "nl": "Nederlandsk",
    "sv": "Svensk",
    "no": "norsk"
  },
  "leave_type_name": {
    "Vacation": "Ferie",
    "Vacation Leave": "Ferie",
    "Annual Leave": "Årlig ferie",
    "Unpaid Vacation": "Ulønnet ferie",
    "Unpaid Leave": "Ulønnet permisjon",
    "Sick Leave": "Sykefravær",
    "Sick Leave (Full Pay)": "Sykefravær (full lønn)",
    "Maternity Leave": "Fødselspermisjon",
    "Paternity Leave": "Pappapermisjon",
    "Parental Leave": "Foreldrepermisjon",
    "Bereavement Leave": "Permisjon ved dødsfall",
    "Marriage Leave": "Bryllupspermisjon",
    "Jury Leave": "Jurypermisjon",
    "Jury Duty": "Juryplikt",
    "Work Travel": "Tjenestereise",
    "Working Remotely": "Hjemmekontor",
    "Remote Work": "Hjemmekontor",
    "Work From Home": "Hjemmekontor",
    "Personal Day": "Personlig dag",
    "TOIL": "Avspasering",
    "Time Off In Lieu": "Avspasering",
    "Compassionate Leave": "Velferdspermisjon",
    "Study Leave": "Studiepermisjon",
    "Training": "Opplæring",
    "Public Holiday": "Helligdag"
  }
}